import React, { PropTypes, PureComponent } from 'react';
import SaveCancelModal from './SaveCancelModal';
import LabelBracketForm from '../forms/LabelBracketForm';

export default class LabelBracketModal extends PureComponent {
  static propTypes = {
    ...SaveCancelModal.propTypes,
    ...LabelBracketForm.propTypes
  };

  static defaultProps = {};

  render() {
    const { value, onChange, ...rest } = this.props;

    return (
      <SaveCancelModal title="Generate Bracket Labels" {...rest}>
        <LabelBracketForm onChange={onChange} value={value}/>
      </SaveCancelModal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/modals/LabelBracketModal.jsx